var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpenses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 3.5V2.66667C4 1.74619 4.74619 1 5.66667 1H17.3333C18.2538 1 19 1.74619 19 2.66667V14.3333C19 15.2538 18.2538 16 17.3333 16H16.5M7 15V8H9.35294C9.78977 8 10.2087 8.15804 10.5176 8.43934C10.8265 8.72064 11 9.10218 11 9.5C11 9.89782 10.8265 10.2794 10.5176 10.5607C10.2087 10.842 9.78977 11 9.35294 11H7M6 13H10M2.66667 19H14.3333C15.2538 19 16 18.2538 16 17.3333V5.66667C16 4.74619 15.2538 4 14.3333 4H2.66667C1.74619 4 1 4.74619 1 5.66667V17.3333C1 18.2538 1.74619 19 2.66667 19Z",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpenses);
export default __webpack_public_path__ + "static/media/expenses.2daab13c6feb2fe22775109ab3f337b8.svg";
export { ForwardRef as ReactComponent };